import { useSelector } from 'react-redux'
import { trackMetric } from 'helpers/metrics'

// Components
import { ReactComponent as Dailymotion } from 'img/icons/dailymotion.svg'
import { ReactComponent as Facebook } from 'img/icons/facebook.svg'
import { ReactComponent as Instagram } from 'img/icons/instagram.svg'
import { ReactComponent as LinkedIn } from 'img/icons/linkedin.svg'
import { ReactComponent as Snapchat } from 'img/icons/snapchat.svg'
import { ReactComponent as Spotify } from 'img/icons/spotify.svg'
import { ReactComponent as TikTok } from 'img/icons/tiktok.svg'
import { ReactComponent as Twitch } from 'img/icons/twitch.svg'
import { ReactComponent as Twitter } from 'img/icons/twitter.svg'
import { ReactComponent as YouTube } from 'img/icons/youtube.svg'

// Styles
import styles from './SocialLinks.module.scss'

const SocialLinks = ({ socials }) => {
  const subdomain = useSelector(state => state.common.subdomain)

  return (
    <div className={styles.social}>
      {socials.map(social => {
        return (
          <a
            href={social.url}
            key={social.text}
            onClick={e => trackMetric(`social_${social.text.toLowerCase()}`, e)}
            target="_blank"
            rel="noreferrer"
          >
            {getSocialIcon(social.text)}
          </a>
        )
      })}
      {subdomain === 'omarapollo' && (
        <a
          href={
            'https://open.spotify.com/artist/5FxD8fkQZ6KcsSYupDVoSO?si=vSklIqRTTmKNmgjQ4HjAFg'
          }
          onClick={e => trackMetric('social_spotify', e)}
          target="_blank"
          rel="noreferrer"
        >
          {getSocialIcon('spotify')}
        </a>
      )}
    </div>
  )
}

export default SocialLinks

const getSocialIcon = name => {
  switch (name.toLowerCase()) {
    case 'twitter':
      return <Twitter />
    case 'youtube':
      return <YouTube />
    case 'instagram':
      return <Instagram />
    case 'snapchat':
      return <Snapchat />
    case 'tiktok':
      return <TikTok />
    case 'facebook':
      return <Facebook />
    case 'linkedin':
      return <LinkedIn />
    case 'twitch':
      return <Twitch />
    case 'dailymotion':
      return <Dailymotion />
    case 'spotify':
      return <Spotify />
    default:
      break
  }
}
